import { render, staticRenderFns } from "./index.vue?vue&type=template&id=659081ce&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrderReview: require('/app/components/user/OrderReview/OrderReview.vue').default,UIActionEntity: require('/app/data/UIActionEntity/UIActionEntity.vue').default})
